import { render, staticRenderFns } from "./PartsSummaryMobile.vue?vue&type=template&id=4d887b0a&scoped=true"
import script from "./PartsSummaryMobile.vue?vue&type=script&lang=ts"
export * from "./PartsSummaryMobile.vue?vue&type=script&lang=ts"
import style0 from "./PartsSummaryMobile.vue?vue&type=style&index=0&id=4d887b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d887b0a",
  null
  
)

export default component.exports